import React, { FormEvent, useEffect, useState } from 'react';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import LeaseRecording from 'src/models/dlcLease/LeaseRecording';
import LeaseRecordingCard from './LeaseRecordingCard';
import PagedResultSet from 'src/models/common/PagedResultSet';

interface ILeaseRecordingListComponentProps {
    leaseRecordings: PagedResultSet<LeaseRecording>;
    forBatching: boolean;
    isAssigned: boolean;
    selectList: number[];
    updateSelectList?: (e: FormEvent<HTMLInputElement>, recordingId: number) => void;
    onUpdateLeaseRecording?: (leaseNumber: number, id: number) => void;
    incrementPage?: () => void;
}

const LeaseRecordingsList = (props: ILeaseRecordingListComponentProps) => {
    const formBuffer = props.forBatching ? 5 : 0;

    const [showNextPage, setShowNextPage] = useState<boolean>(false);

    useEffect(() => {
        if (!!props.leaseRecordings) {
            setShowNextPage(props.leaseRecordings.pageNumber * props.leaseRecordings.pageSize < props.leaseRecordings.totalRecords);
        }
    }, [props.leaseRecordings]);

    const processingCards = (obj: LeaseRecording) => {
        let selected = props.selectList.indexOf(obj.lr_tg) > -1;

        return (
            <div key={obj.lr_tg}>
                <LeaseRecordingCard
                    leaseRecording={obj}
                    forBatching={props.forBatching}
                    disabled={props.isAssigned}
                    selected={selected}
                    handleRecordingSelect={props.updateSelectList}
                    onUpdateLeaseRecording={props.onUpdateLeaseRecording}
                />
            </div>
        );
    };

    const onLRIncrement = () => {
        setShowNextPage(false);
        props.incrementPage();
    };

    const newCard = () => {
        return (
            <CardContainer nextPageAction={onLRIncrement} showNextPagePanel={showNextPage} buttonPaging={true}>
                {(props.leaseRecordings?.items?.length > 0) && props.leaseRecordings.items.map(processingCards)}
                {(props.leaseRecordings === undefined || props.leaseRecordings?.items?.length === 0) && (
                    <Card>
                        <div className="agreements-card">
                            <div style={{ textAlign: 'center' }}>
                                <p>No Lease Records Found!</p>
                            </div>
                        </div>
                    </Card>
                )}
            </CardContainer>
        );
    };

    const headerList = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 1rem' }}>
                {props.forBatching && (
                    <div className="form-field" style={{ width: `${formBuffer}%` }}>Select</div>
                )}
                <div className="form-field" style={{ width: `${60 - formBuffer}%` }}>Lessor Name</div>
                <div className="form-field" style={{ width: '10%' }}>Book/Doc No.</div>
                <div className="form-field" style={{ width: '10%' }}>Page</div>
                {!props.forBatching && (
                    <>
                        <div className="form-field" style={{ width: '10%' }}>Asgn?</div>
                        <div className="form-field" style={{ width: '10%' }}>Tran?</div>
                    </>
                )}
                {props.forBatching && (
                    <div className="form-field" style={{ width: '20%' }}>Working Interest</div>
                )}
            </div>
        );
    };

    return (
        <>
            {headerList()}
            {newCard()}
        </>
    );
};

export default LeaseRecordingsList;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/LeaseRecordingsList.tsx